import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 6.25rem auto 0;
  color: white;
`;
